import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  noAppAvailable: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.text.hint,
    fontSize: 20
  },
  applicationsList: {
    width: "100%",
    padding: 20,
    display: "flex",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      flexDirection: "column",
      padding: 0
    }
  },
  appLabel: {
    padding: "14px 20px",
    display: "flex",
    alignItems: "center",
    border: "1px solid grey",
    borderRadius: "4px",
    marginBottom: 10,
    flexBasis: "50%",
    alignSelf: "flex-start",
    "&.first": {
      marginRight: 20,
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        margin: 0
      }
    },
    "&:hover": {
      cursor: "pointer"
    },
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      margin: 0,
      borderRadius: 0,
      border: "none",
      borderBottom: "1px solid #e2e2e2",
      width: "100%"
    }
  },
  appLabelIconContainer: {
    minWidth: 36,
    minHeight: 36,
    backgroundColor: "black",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 14
  },
  appLabelContentContainer: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  appLabelName: {},
  mainName: {
    fontSize: 14,
    fontWeight: 600
  },
  description: {
    fontSize: 13,
    color: theme.palette.text.secondary
  },
  appItemIcon: {
    color: "white",
    fontSize: 20
  },
  openAppIcon: {
    color: theme.palette.text.secondary,
    fontSize: 20
  }
}));
